import { useState } from "react";
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from "react-query";
import { MessageModalContent } from '@components/modals/MessageModalNew';
import TextInput from "@components/TextInput/TextInput";
import { Modal, ModalSize } from "@components/new/Modal";
// import { ButtonType } from "@components/new/Button";
import {
  mergeSellers,
} from "@api/apiClient/fbp";
import styles from "./LinkModal.module.scss";

interface LinkModalProps {
  onClose: () => void;
  sellerWarehouseIds: string[];
}

enum steps {
  FORM = "form",
  SUCCESS = "success",
  ERROR = "error",
}

const LinkModal = ({ onClose, sellerWarehouseIds }: LinkModalProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [step, setStep] = useState<steps>(steps.FORM);
  const [name, setName] = useState<string>("");

  const mergeMutation = useMutation({
    mutationFn: mergeSellers,
    onSuccess: () => {
      setStep(steps.SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["getWarehouses"] })
    },
    onError: () => setStep(steps.ERROR),
  });

  if (step === steps.SUCCESS) {
    return (
      <Modal
        isOpen={true}
        size={ModalSize.M}
        onClose={onClose}
        footerButtons={[
          {
            title: t('fbpPage.storesUnion.closeBtn'),
            onClick: onClose,
          },
        ]}
      >
        <MessageModalContent
          title={t('fbpPage.storesUnion.linkModalSuccessTitle')}
          description={t('fbpPage.storesUnion.linkModalSuccessDescription', { name })}
          variant="success"
        />
      </Modal>
    )
  }

  if (step === steps.ERROR) {
    return (
      <Modal
        isOpen={true}
        size={ModalSize.M}
        onClose={onClose}
        footerButtons={[
          {
            title: t('fbpPage.storesUnion.closeBtn'),
            onClick: onClose,
          },
        ]}
      >
        <MessageModalContent
          title={t('fbpPage.storesUnion.linkModalErrorTitle')}
          description={t('fbpPage.storesUnion.linkModalErrorDescription')}
          variant="warning"
        />
      </Modal>
    )
  }

  return (
    <Modal
      isOpen={true}
      title={t('fbpPage.storesUnion.linkName')}
      size={ModalSize.M}
      onClose={onClose}
      footerButtons={[
        {
          title: t('fbpPage.storesUnion.cancelBtn'),
        },
        {
          title: t('fbpPage.storesUnion.saveBtn'),
          onClick: () => {
            mergeMutation.mutate({
              sellerWarehouseIds,
              newSellerWarehouseName: name,
            });
            setStep(steps.SUCCESS);
          },
          disabled: !name.trim().length,
          loading: false,
        },
      ]}
    >
      <div className={styles.section}>
        <TextInput
          value={name}
          onChange={setName}
          description={t('fbpPage.storesUnion.linkNameDescription')}
          maxLength={100}
        />
      </div>
    </Modal>
  )
}

export default LinkModal;
